import { defineAsyncComponent } from 'vue'
export default {
  clean: defineAsyncComponent(() => import("/app01/layouts/clean.vue")),
  default: defineAsyncComponent(() => import("/app01/layouts/default.vue")),
  game: defineAsyncComponent(() => import("/app01/layouts/game.vue"))
}